// extracted by mini-css-extract-plugin
export default {"header":"Heading_header__sgrzr"};